import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-colored-background',
  imports: [CommonModule],
  template: `
    <div class="colored-background-container" [style.background-color]="backgroundColor">
      <ng-content></ng-content>
    </div>
  `,
  styles: [`
    .colored-background-container {
      position: relative;
      z-index: -0;
    }
  `]
})
export class ColoredBackgroundComponent {
  @Input()
  backgroundColor: string = '#894AD9';
}
